import { apiSlice } from "./apiSlice";

export const partnerApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    addPartner: builder.mutation({
      query: (partnerData) => ({
        url: "/partners/addNewPartner",
        method: "POST",
        body: partnerData,
      }),
      invalidatesTags: ["Partners"],
    }),

    deletePartner: builder.mutation({
      query: (id) => ({
        url: `/partners/deletePartner/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Partners"],
    }),

    updatePartner: builder.mutation({
      query: ({ partnerData, id }) => ({
        url: `/partners/updatePartner/${id}`,
        method: "PATCH",
        body: partnerData,
      }),
      invalidatesTags: ["Partners"],
    }),

    getAllPartners: builder.query({
      query: ({ page = 1, search } = {}) => {
        const params = new URLSearchParams();
        params.append("page", page);
        if (search) params.append("search", search);

        return {
          url: `/partners/getAllPartners?${params.toString()}`,
          method: "GET",
        };
      },

      providesTags: ["Partners"],
    }),
    getPartnerById: builder.query({
      query: (id) => ({
        url: `/partners/getPartnerById/${id}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useAddPartnerMutation,
  useUpdatePartnerMutation,
  useDeletePartnerMutation,
  useGetAllPartnersQuery,
  useGetPartnerByIdQuery,
} = partnerApi;
